import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { AppKey } from '../app/AppKey';
import { getSentryExtra } from '../error/getSentryExtra';
import { OAuthProviders } from '../oauth/OAuthProviders';
import { setIsAppleLoading, setWhichOAuthSelected, updateKeyValue } from '../store/app/action-creators';
import { oAuthAuthFailed, oAuthAuthStarted, oAuthAuthSucceeded, verifyOAuthVerificationPayload } from '../store/oauth/action-creators';
import { Tracker } from '../store/tracking/action-creators';
import { getAppleAuthClient, getNameFromAppleUser } from './appleUtils';
import Logger from '../lib/Logger';
const LOG = Logger.getLogger('useAppleOAuthSignIn');
export const useAppleOAuthSignIn = ({
  shouldSignInWithApple,
  setShouldSignInWithApple
}) => {
  const dispatch = useDispatch();
  const appleAuthClient = getAppleAuthClient();
  useEffect(() => {
    if (shouldSignInWithApple && appleAuthClient) {
      dispatch(oAuthAuthStarted(OAuthProviders.Apple));
      dispatch(setWhichOAuthSelected(OAuthProviders.Apple));
      appleAuthClient.auth.signIn().then(res => {
        dispatch(setIsAppleLoading(true));
        const {
          authorization,
          user
        } = res;
        dispatch(oAuthAuthSucceeded({
          token: authorization.id_token
        }, OAuthProviders.Apple));
        dispatch(Tracker.signupInteraction('apple-button-click'));
        dispatch(updateKeyValue(AppKey.FirstOAuthPartnerClick, OAuthProviders.Apple));
        dispatch(verifyOAuthVerificationPayload(Object.assign({
          idToken: authorization.id_token,
          nonce: ''
        }, getNameFromAppleUser(user)), OAuthProviders.Apple)).catch(error => {
          LOG.error('Error during verification of the apple id token', {
            extra: getSentryExtra(error)
          });
        });
      }).catch(({
        error
      }) => {
        dispatch(oAuthAuthFailed(error, OAuthProviders.Apple));

        if (error === 'popup_closed_by_user') {
          LOG.warn(`Apple User Cancelled Flow by Closing the popup`, {
            extra: getSentryExtra(error)
          });
        } else {
          LOG.error(`Error with Apple Authentication`, {
            extra: getSentryExtra(error)
          });
        }

        dispatch(updateKeyValue(AppKey.WhichOAuthEndpointFailed, OAuthProviders.Apple));
        setShouldSignInWithApple(false);
      });
    }
  }, [appleAuthClient, shouldSignInWithApple, setShouldSignInWithApple, dispatch]);
};